module.exports = __webpack_public_path__ + "static/PokemonShowdown-183b4a1b03c69e012fbc675a9eea76dc.jpg";